export default "__VITE_ASSET__7a8b5dc9__"